import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";

export const NotificationLMSAdd: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkAddInfo;

    if (!lmsInfo) return null;

    return <SimpleTitle>
        <a href={window.location.origin + '/designer/' + lmsInfo?.student?.accountId}>
            {`${lmsInfo?.student?.name} ${lmsInfo?.student?.surName}`}
        </a>
        {` добавил домашнее задание на тему `}
        <a href={process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.checkHomework(lmsInfo?.studentId, lmsInfo?.moduleProjectId, lmsInfo?.themeLongreadId)}>
            "{lmsInfo?.themeTitle}"
        </a>
    </SimpleTitle>
}import React, {FC} from "react";
import {SimpleTitle} from "../styles";
import {CreateLinkTo} from "../../../constants/linkTo";

export const NotificationLMSAdd: FC<{item: any}> = ({item}) => {

    const {
        actions,
    } = item;

    const lmsInfo = actions[0]?.lmsHomeWorkAddInfo;

    if (!lmsInfo) return null;

    return <SimpleTitle>
        <a href={window.location.origin + '/designer/' + lmsInfo?.student?.accountId}>
            {`${lmsInfo?.student?.name} ${lmsInfo?.student?.surName}`}
        </a>
        {` добавил домашнее задание на тему `}
        <a href={process.env.REACT_APP_URL_HSEDESIGN_LMS + CreateLinkTo.checkHomework(lmsInfo?.studentId, lmsInfo?.moduleProjectId, lmsInfo?.themeLongreadId)}>
            "{lmsInfo?.themeTitle}"
        </a>
    </SimpleTitle>
}